import request from '@/utils/request'
import config from '@/config'
export default {
  getOverflow30mmRainBefore1Hour (params) {
    return request.get(config.ApiYSQ + '/HydrologyCenter/GetOverflow30mmRainBefore1Hour', { params })
  },
  getOverflow50mmRainBefore3Hour (params) {
    return request.get(config.ApiYSQ + '/HydrologyCenter/GetOverflow50mmRainBefore3Hour', { params })
  }
}
